import { useCurrentDocument } from '@/components/YjsProvider';
import { getRootMap, useObservedProperty } from '@/utils/yjs';

export enum ActivityScoreWeight {
  automatic = 'automatic',
  manual = 'manual'
}

export function useActivityScoreWeight() {
  const document = useCurrentDocument();
  const rootMap = getRootMap(document);
  return useObservedProperty<ActivityScoreWeight>(rootMap, 'activityScoreWeight');
}
